import {
  IdeasDisplayEnum,
  IdeasTimespanEnum,
  LeaderboardTypeEnum,
  PanelType,
  VideoEmbedTypeEnum
} from '../../../common/core-api';
import { AUTO_PANEL_SIZE, type PageCmsPanel, type PanelConfigTypename } from './panel-types';

const createPanelId = (): string => Math.random().toString(9).slice(-10);

const defaultSettings: Record<PanelConfigTypename, () => PageCmsPanel['settings']> = {
  TextPanelSettings: () => ({
    __typename: 'TextPanelSettings',
    type: PanelType.TEXT,
    size: AUTO_PANEL_SIZE,
    text: '',
    buttonConfig: null
  }),
  ImagePanelSettings: () => ({
    __typename: 'ImagePanelSettings',
    type: PanelType.IMAGE,
    size: AUTO_PANEL_SIZE,
    imageFile: null,
    imageWidth: null,
    imageAltText: null,
    imageRoundedCorners: false,
    buttonConfig: null
  }),
  VideoPanelSettings: () => ({
    __typename: 'VideoPanelSettings',
    type: PanelType.VIDEO,
    size: AUTO_PANEL_SIZE,
    embed: VideoEmbedTypeEnum.LINK,
    videoUrl: null,
    videoEmbedCode: null
  }),
  ChallengeCarouselPanelSettings: () => ({
    __typename: 'ChallengeCarouselPanelSettings',
    type: PanelType.CHALLENGECAROUSEL,
    size: AUTO_PANEL_SIZE,
    favourites: false,
    hideDescription: false,
    includeUserChallenges: false
  }),
  ActivityPanelSettings: () => ({
    __typename: 'ActivityPanelSettings',
    type: PanelType.ACTIVITY,
    size: AUTO_PANEL_SIZE
  }),
  LeaderboardPanelSettings: () => ({
    __typename: 'LeaderboardPanelSettings',
    type: PanelType.LEADERBOARD,
    size: AUTO_PANEL_SIZE,
    leaderboardDisplay: [LeaderboardTypeEnum.leaderboard, LeaderboardTypeEnum.newbies],
    leaderboardDefault: LeaderboardTypeEnum.leaderboard
  }),
  IdeasPanelSettings: () => ({
    __typename: 'IdeasPanelSettings',
    type: PanelType.IDEAS,
    size: AUTO_PANEL_SIZE,
    ideasDisplay: [
      IdeasDisplayEnum.trend,
      IdeasDisplayEnum.latest,
      IdeasDisplayEnum.voted,
      IdeasDisplayEnum.random,
      IdeasDisplayEnum.commented
    ],
    ideasDefault: IdeasDisplayEnum.trend,
    timespan: IdeasTimespanEnum.DAYS_30
  }),
  BlogCarouselPanelSettings: () => ({
    __typename: 'BlogCarouselPanelSettings',
    type: PanelType.BLOGCAROUSEL,
    size: AUTO_PANEL_SIZE
  }),
  LinePanelSettings: () => ({
    __typename: 'LinePanelSettings',
    type: PanelType.LINE,
    size: AUTO_PANEL_SIZE
  })
};

export const createPanel = (typename: PanelConfigTypename): PageCmsPanel => ({
  id: createPanelId(),
  settings: defaultSettings[typename]()
});
